import { useMemo } from "react";
import { useFetch } from "../../core/hooks/useFetch";
import { ApiFactory } from "../../core/config/ApiFactory";
import { IProgramaFidelidade } from "../interface/IProgramaFidelidade";

export const useFetchProgramasFidelidade = () => {
    const api = useMemo(() => ApiFactory.getApi("MS_ESTABELECIMENTOS"), []);
    const { data: programas, isLoading, error } = useFetch<IProgramaFidelidade[]>(api, "/programas-fidelidade?ativo=true");
    return { programas, isLoading, error };
};
